import { ExportNew } from 'src/components/export-new';

export default ExportNew;
